import "../styles/quote-form.css";

const regions = ["Región Metropolitana de Santiago"];

const QuoteForm = () => (
  <div className="landing-container quote-form-page">
    <section className="quote-form-card">
      <h1>Cotiza tu proyecto con nosotros</h1>

      <form className="quote-form-grid" onSubmit={(event) => event.preventDefault()}>
        <label className="quote-form-field">
          <span>Nombre *</span>
          <input type="text" disabled placeholder="" />
        </label>

        <label className="quote-form-field">
          <span>RUT</span>
          <input type="text" disabled placeholder="" />
        </label>

        <label className="quote-form-field quote-form-field-full">
          <span>Nombre de la empresa o razón social</span>
          <input type="text" disabled placeholder="" />
        </label>

        <label className="quote-form-field">
          <span>Correo electrónico *</span>
          <input type="email" disabled placeholder="" />
        </label>

        <label className="quote-form-field">
          <span>Teléfono</span>
          <input type="text" disabled placeholder="" />
        </label>

        <label className="quote-form-field">
          <span>Región</span>
          <select disabled defaultValue={regions[0]}>
            {regions.map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>
        </label>

        <label className="quote-form-field">
          <span>Comuna</span>
          <input type="text" disabled placeholder="" />
        </label>

        <label className="quote-form-field quote-form-field-full">
          <span>Mensaje *</span>
          <textarea rows={6} disabled placeholder="" />
        </label>

        <div className="quote-form-note quote-form-field-full">
          Gracias por ponerse en contacto con nosotros. Nos pondremos en contacto con usted lo antes posible.
        </div>

        <div className="quote-form-actions quote-form-field-full">
          <button type="submit" disabled>
            Enviar
          </button>
        </div>
      </form>
    </section>
  </div>
);

export default QuoteForm;
